<template>
  <div class="OrderList">
    <el-container  v-for="(order,i) in list" :key="i">
      <el-header class="order_header">
        <div class="order_num">订单编号：{{order.num}}</div>
        <div class="order_status">{{order.status}}</div>
      </el-header>
      <el-container>
        <el-aside width="30%">
          <img :src="getImgUrl('propic/'+order.productModel+'.png')" alt="" class="product-img">
        </el-aside>
        <el-main class="order_body_right">
          <div class="order_title">{{order.title}}</div>
          <div class="order_address">{{order.address}}</div>
          <div class="order_createTime">预约时间:{{order.createTimeStr}}</div>
          <div class="order_createTime" v-if="order.status=='完结'||order.status=='已回访'">完工时间:{{order.updateTimeStr}}</div>
        </el-main>
      </el-container>
<!--      <el-footer>Footer</el-footer>-->
      <el-divider class="info-divider"></el-divider>
    </el-container>
  </div>
</template>

<script>
    export default {
        name: "OrderList",
        props: {
            list: {
                type: Array,
                default: () => []
            },
        },
        methods:{
            getImgUrl(icon){
                return require("@/assets/"+icon);
            },
        },
        created() {
            // console.log("OrderList: created()");
        }
    }
</script>

<style scoped>
  .order_header{
    height: auto!important;
    font-size: 15px;
    color: #333333;
  }
  .order_num {
    display: inline-block;
    float: left;
  }
  .order_status {
    display: inline-block;
    float: right;
  }
  .product-img {
    padding-left: 20px;
    padding-top: 10px;
  }
  .order_body_right {
    padding: 20px 20px 0px 20px;
  }
  .order_title {
    text-align: left;
    margin-bottom: 20px;
  }
  .order_address {
    text-align: left;
    color: #999999;
    font-size: 13px;
  }
  .order_createTime {
    text-align: left;
    color: #999999;
    font-size: 12px;
  }
  .info-add {
    text-align: left;
    margin: 10px 0px;
  }
  .info-add p {
    display:inline-block;
    font-size: 15px;
    margin: 0px 15px 6px 15px;
    color: #333333;
  }
  .list_username {
    font-weight: 600;
  }
  .list_address {
    margin: 0px 0px 0px 15px;
    color: #999999;
    font-size: 12px;
  }
</style>
<style>

</style>
